module.exports = new __parcel__URL__("triggers_empty_state.7b4ff42b.svg").toString();